import type { Prototype } from "../prototype-types";

export const tanyaMaPrototypes: Prototype[] = [
  {
    id: "faire-ads-vision",
    name: "Faire Ads Vision",
    path: "/tm/faire-ads-vision",
    description:
      "Four presentations of the same goal-first Ads Manager, compared side by side: a plan table, a conversational growth manager, a demand map, and a single-goal default. Goal drives plan drives allocation; Faire sets the allocation and the brand controls the cap, the opt-ins, and the approvals.",
    owner: "Tanya Ma",
    createdAt: "2026-09-15",
    lastUpdated: "2026-09-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "/images/thumbnails/faire-ads-vision.png",
    creationTool: "cursor",
    project: "Faire Ads Vision",
  },
  {
    id: "ads-retailer-category-controls",
    name: "Ads Category Controls",
    path: "/tm/faire/ads-retailer-category-controls",
    description:
      "Retailer categories tab (delivery reporting by store type) + Category preferences section on Advertising settings. Brands set preferred retailer types in settings; reporting tab shows where delivery shifts.",
    owner: "Tanya Ma",
    createdAt: "2026-06-03",
    lastUpdated: "2026-06-03",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/d5c154dbfb80705dc7260160dc0fbfe16e35f9a97f367cea5811baf48a9fba76.png",
    creationTool: "cursor",
  },
  {
    id: "ads-home-widget",
    name: "Ads Home Widget",
    path: "/tm/faire/ads-home-widget",
    description:
      "Brand-portal home page with a new Promoted Listings performance widget (ROAS, ad spend, new customers) inserted between Open orders and Top Shop. Uses Sweet Water Decor, March 2026 data.",
    owner: "Tanya Ma",
    createdAt: "2026-04-20",
    lastUpdated: "2026-04-20",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a9204a632b167210426f6f4d7f7c3bad003f6feb23434df8246ae2374ca08332.png",
    creationTool: "cursor",
  },
  {
    id: "promoted-listings-budget-flex",
    name: "Promoted Listings Budget Flex",
    path: "/tm/faire/promoted-listings-budget-flex",
    description:
      "Brand-side promoted listings prototype that combines advertising settings and overview states to show how flexible budget controls affect base vs flexible spend.",
    owner: "Tanya Ma",
    createdAt: "2026-04-14",
    lastUpdated: "2026-04-15",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/4b81c739f22add853613716d1ae4b650df05ec822f9e802c503aaba5ff4baa6a.png",
    creationTool: "cursor",
  },
  {
    id: "promoted-listings-2027",
    name: "Promoted Listings 2027",
    path: "/tm/faire/promoted-listings-2027",
    description:
      "Intent-driven promoted listings settings page. Advertisers express goals (ROAS, visibility, product focus, category/geo expansion) and set constraints via an AI chat panel — no manual campaign configuration.",
    owner: "Tanya Ma",
    createdAt: "2026-03-26",
    lastUpdated: "2026-03-26",
    surfaceArea: "Brand",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e612a0e8fef7338fb3b010400c4410f88ed7ce4e8bfee1902a968050e3e00941.png",
    creationTool: "cursor",
  },
  {
    id: "tm-scenario-planning-tool",
    name: "Scenario Planning Tool",
    path: "/tm/scenario-planning-tool",
    description:
      "Promoted Listings advertising settings with a live monthly forecast: the budget input and growth mode setting drive predicted sales, conversions, ROAS, and expected spend so brands can plan scenarios before saving.",
    owner: "Tanya Ma",
    project: "Promoted Listings",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tm-scenario-planning-tool.png",
    creationTool: "cursor",
  },
];
